"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoStyle = void 0;
var qwilr_logo_v_dark_svg_1 = __importDefault(require("@ClientAssets/icons/qwilr-logo-v-dark.svg"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var LogoStyle;
(function (LogoStyle) {
    LogoStyle["Branded"] = "branded";
    LogoStyle["Minimal"] = "minimal";
})(LogoStyle = exports.LogoStyle || (exports.LogoStyle = {}));
var Masthead = (0, mobx_react_1.observer)(function (props) {
    var _a;
    var _b;
    var logoSrc = (_a = {}, _a[LogoStyle.Branded] = qwilr_logo_v_dark_svg_1.default, _a[LogoStyle.Minimal] = "/Assets/icons/QwilrLogo.svg", _a)[(_b = props.logoStyle) !== null && _b !== void 0 ? _b : LogoStyle.Branded];
    return (react_1.default.createElement("div", { className: "masthead" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("masthead__header", {
                "masthead__header--minimal": props.logoStyle === LogoStyle.Minimal,
            }) },
            props.back ? (react_1.default.createElement("div", { className: "masthead__left" },
                react_1.default.createElement(kaleidoscope_1.Button, { className: "masthead__back", type: kaleidoscope_1.ButtonType.Tertiary, onClick: props.back, size: kaleidoscope_1.ButtonSize.Small },
                    react_1.default.createElement(icons_1.ArrowLeft, { size: icons_1.IconSize.Small }),
                    "Back"))) : undefined,
            react_1.default.createElement(kaleidoscope_1.SVG, { className: (0, classnames_1.default)("masthead__icon", { "masthead__icon--minimal": props.logoStyle === LogoStyle.Minimal }), src: logoSrc })),
        props.explainer ? react_1.default.createElement("p", { className: "masthead__explainer" }, props.explainer) : undefined,
        props.children));
});
exports.default = Masthead;
